import Component from "../../lib/component";

export const TogglerPaneConfig = {
    componentTypeKey: 'TogglerPane',
    baseHtmlClass: 'toggler_pane',
    selector: '.toggler_pane',
};

export class TogglerPane extends Component {

    constructor(id_or_element, togglerBtn, togglerBtns) {
        super({
            element: id_or_element,
            config: TogglerPaneConfig
        });

        this.element.classList.add(TogglerPaneConfig.baseHtmlClass); // In case the class wasn't already applied.

        this.togglerBtn = togglerBtn;
        this.togglerBtns = togglerBtns;

        this.isActive = this.togglerBtn.isActive;

        this.render();
    }

    activate() {
        this.isActive = true;
        this.togglerBtns.setUrlHashForPaneId(this.element.id);
        this.render();
    }

    deactivate() {
        this.isActive = false;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.isActive, 'active');
    }

}